export default __webpack_public_path__ + "static/ultra_glow-33cf0f74b605bbf21abf9c62143d5ede.png";